module.exports = __webpack_public_path__ + "img/file_icon.3ff53662.svg";